import { PageUrl } from '../pages';

export enum OSSPLinkPlaceholders {
  BOOKING_OVERVIEW = 'BOOKING_OVERVIEW',
  DOCUMENTS = 'DOCUMENTS',
  PAYMENT_STATUS = 'PAYMENT_STATUS',
  CHANGE_BOOKING = 'CHANGE_BOOKING',
  BOOKING_NOTES = 'BOOKING_NOTES',
  VIDEO = 'VIDEO',
  EXTRAS = 'EXTRAS',
  INFORMATION = 'INFORMATION'
}

export enum OSSPPlaceholders {
  TRAVEL_START_DATE = 'TRAVEL_START_DATE',
  TRAVEL_END_DATE = 'TRAVEL_END_DATE',
  BOOKING_DATE = 'BOOKING_DATE'
}

export const OSSPPlaceholderToPageConfig: Map<string, string> = new Map([
  [OSSPLinkPlaceholders.BOOKING_OVERVIEW, `${PageUrl.MANAGE_BOOKING}?section=booking-overview`],
  [OSSPLinkPlaceholders.DOCUMENTS, PageUrl.DOCUMENTS],
  [OSSPLinkPlaceholders.PAYMENT_STATUS, PageUrl.PAYMENT_STATUS],
  [OSSPLinkPlaceholders.CHANGE_BOOKING, PageUrl.CHANGE_BOOKING],
  [OSSPLinkPlaceholders.BOOKING_NOTES, PageUrl.BOOKING_NOTES],
  [OSSPLinkPlaceholders.VIDEO, PageUrl.VIDEO],
  [OSSPLinkPlaceholders.EXTRAS, `${PageUrl.EXTRAS_PAGE}?addExtraWorkflow=true`],
  [OSSPLinkPlaceholders.INFORMATION, PageUrl.INFORMATION]
]);
